import { render, staticRenderFns } from "./FreeMonthsBenefitNotificationBox.vue?vue&type=template&id=5e296d75&scoped=true&"
import script from "./FreeMonthsBenefitNotificationBox.vue?vue&type=script&lang=js&"
export * from "./FreeMonthsBenefitNotificationBox.vue?vue&type=script&lang=js&"
import style0 from "./FreeMonthsBenefitNotificationBox.vue?vue&type=style&index=0&id=5e296d75&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e296d75",
  null
  
)

export default component.exports